import type { ReactNode } from "react";
import type { AssetSlotId } from "../../types/content";
import { ImageSlot } from "./ImageSlot";

type PageHeroProps = {
  eyebrow: string;
  title: string;
  description: string;
  imageSlot: AssetSlotId;
  imageAlt: string;
  children?: ReactNode;
};

export function PageHero({ eyebrow, title, description, imageSlot, imageAlt, children }: PageHeroProps) {
  return (
    <section className="page-hero">
      <div className="container page-hero__grid">
        <div className="page-hero__content reveal">
          <p className="eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          <p>{description}</p>
          {children && <div className="page-hero__actions">{children}</div>}
        </div>
        <ImageSlot slot={imageSlot} alt={imageAlt} priority aspect="wide" className="page-hero__image reveal" />
      </div>
    </section>
  );
}
